import React from "react";

import { withRouter } from "react-router-dom";

import Listx from "../../../../../../components/listx";

class List extends Listx {

  constructor(props) {
    super(props);

    this.headings = [
      { id: '#', label: '#' },
      { id: 'title', label: 'Title' },
      { id: 'start', label: 'Start' },
      { id: 'duration', label: 'Duration' },
      { id: 'limit', label: 'Limit' },
    ];
  }

  renderRowData(data){
    return [
      this.renderCell(
        <>
        {data.title}
        {data.description  ? 
        (<><br/><strong>Note : </strong>{data.description}</>) : (<></>)
        }
        </>
      ),
      this.renderCell(data.start),
      this.renderCell(data.duration_str),
      this.renderCell(data.limit),
      this.renderCell(
        <>
        {this.defaultActions(data.id)}
        </>
      , null, true),
    ];
  }

}

export default withRouter(List);